import React from 'react';

const Recycle = () => {
  return (
    <svg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.6849 35.2546H6.33487C3.14558 35.2546 1.05094 32.355 2.43295 29.8532L7.31337 21.0184M27.8617 35.2546H35.6647C38.9011 35.2546 40.9933 32.2768 39.5188 29.7692L34.3729 21.0184M28.7919 11.5276L24.3956 4.05145C22.7645 1.27781 18.1908 1.32735 16.6396 4.13546L12.5562 11.5276M12.979 40L17.3816 36.1395C17.9402 35.6497 17.9402 34.8594 17.3816 34.3697L12.979 30.5092M39.944 20.0685L33.9722 18.5746C33.2064 18.3831 32.4066 18.7731 32.1881 19.4445L30.4844 24.681M8.40703 7.96853L10.6412 13.0478C10.9279 13.6998 11.7658 14.0255 12.5093 13.7741L18.302 11.8151'
        stroke='#55BB47'
        stroke-width='3'
        stroke-linecap='round'
      ></path>
    </svg>
  );
};

export default Recycle;
